import { Request } from '../main'
import Link from 'next/link'
import {Image} from 'react-bootstrap'
import { isDomain } from '../utils/general'

const request = new Request(process.env.apiDomain)

function StripContactMe(props) {
    const site = props.site
    const { data: eo } = request.website.swrSite(site.accountId, "EO")
    const { data: profile  } = request.account.swrAccountProfile(site.accountId)

    const eoUrl = eo ? (isDomain(eo.url) ? 'www.'+eo.url : eo.url) : '';

    return (
       
        <div className="stripcontactme border border-width-3 px-md-5 px-3 py-3 mt-5">
            <p><strong>Want to Learn to Earn by Guiding and Teaching?</strong></p>
            <p className="d-flex justify-content-between">
                { profile && profile.phone ? <> <span className="mr-4">Call me for details</span>
                    <Link href={"tel:" + profile.phone}><a className="text-reset h7"><Image width={30} src="/images/general/img-phone01.png" className="mr-1"/> { profile.phone }</a></Link> 
                </> : null }
                { eo ?  <a href={ "//" + eoUrl + "/tour" } className="h7 ml-4"><Image width={40} src="/images/general/img-take-tour01.png" className="mr-2"/><u>Take my guided tour</u></a> : null }
            </p>
        </div>
    )
}

export default StripContactMe
